(() => {
  'use strict';

  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];

  // Dynamic Hero Viewport Height Calculation
  // Keeps hero section extending to the exact bottom edge of the viewport
  function syncHeroHeight() {
    const hero = $('.hero');
    if (!hero) return;
    const ann = $('.po-announcement');
    const hdr = $('[data-pageone-header]');
    const annH = (ann && !ann.hidden) ? ann.getBoundingClientRect().height : 0;
    const hdrH = (hdr && !hdr.hidden) ? hdr.getBoundingClientRect().height : 0;
    const topOffset = annH + hdrH;
    const vh = window.innerHeight;
    const exactHeroH = Math.max(380, Math.round(vh - topOffset));
    document.documentElement.style.setProperty('--hero-dynamic-height', exactHeroH + 'px');
    document.documentElement.style.setProperty('--hero-top-offset', Math.round(topOffset) + 'px');
  }
  syncHeroHeight();
  window.addEventListener('resize', () => requestAnimationFrame(syncHeroHeight), { passive: true });
  window.addEventListener('orientationchange', () => setTimeout(syncHeroHeight, 150), { passive: true });
  document.addEventListener('DOMContentLoaded', syncHeroHeight);

  const text = (tag, value, className) => { const e = document.createElement(tag); e.textContent = value; if (className) e.className = className; return e; };
  const storeKey = 'pageone-quote-shortlist-v1';
  let list = [];
  try { const saved = JSON.parse(localStorage.getItem(storeKey) || '[]'); if (Array.isArray(saved)) list = saved.filter(x => typeof x.title === 'string').map(x => ({title:x.title,quantity:Math.max(1,Math.min(1000000,parseInt(x.quantity,10)||1))})); } catch {}
  const cards = () => $$('.product-card[data-title]');
  const catalog = () => cards().map(card => ({title:card.dataset.title,kind:card.dataset.kind,description:$('.dialog-content',card)?.textContent || '',image:$('.product-image img',card)?.src || '',dialog:$('dialog',card)?.id}));
  const announce = value => { const e = $('[data-global-status]'); if (e) e.textContent = value; };
  let panel = null, panelTrigger = null;
  const inertStates = new Map();
  function setPageInert(value) {
    const headerWrapper = $('[data-pageone-header]')?.closest('.shopify-section') || $('[data-pageone-header]');
    [...document.body.children].forEach(e => {
      if (e === headerWrapper || e.contains($('[data-pageone-header]')) || e.tagName === 'DIALOG' || ['SCRIPT','STYLE','LINK'].includes(e.tagName)) return;
      if(value){inertStates.set(e,e.inert);e.inert=true;} else if(inertStates.has(e)){e.inert=inertStates.get(e);}
    });
    if(!value)inertStates.clear();
  }
  function closePanel(returnFocus = true) {
    if (!panel) return;
    $('#PageOneMenu').hidden = true; $('#PageOneSearch').hidden = true;
    $('[data-panel-backdrop]').hidden = true;
    $('[data-menu-toggle]').setAttribute('aria-expanded','false');
    $('[data-menu-toggle]').setAttribute('aria-label','Open menu');
    $('[data-search-toggle]').setAttribute('aria-expanded','false');
    document.body.classList.remove('po-overlay-open');
    setPageInert(false); panel = null;
    if(returnFocus)panelTrigger?.focus({preventScroll:true});
  }
  function openPanel(name, trigger) {
    if (panel === name) {closePanel();return;}
    closePanel(false); panel = name; panelTrigger = trigger;
    const header = $('[data-pageone-header]'); const bounds=header.getBoundingClientRect();
    header.style.setProperty('--po-panel-top',bounds.bottom+'px');
    $('#PageOneMenu').hidden = name !== 'menu'; $('#PageOneSearch').hidden = name !== 'search';
    $('[data-panel-backdrop]').hidden = false;
    $('[data-menu-toggle]').setAttribute('aria-expanded',String(name === 'menu'));
    $('[data-menu-toggle]').setAttribute('aria-label', name === 'menu' ? 'Close menu' : 'Open menu');
    $('[data-search-toggle]').setAttribute('aria-expanded',String(name === 'search'));
    document.body.classList.add('po-overlay-open'); setPageInert(true);
    if(name==='search') {renderSearch();$('#PageOneSearchInput').focus({preventScroll:true});}
    else $('#PageOneMenu a')?.focus({preventScroll:true});
  }
  function openProduct(id) {
    closePanel(false);
    const dialog = document.getElementById(id);
    if (dialog?.tagName === 'DIALOG' && !dialog.open) dialog.showModal();
  }
  function renderSearch() {
    const results=$('[data-search-results]');if(!results)return;
    const query=($('#PageOneSearchInput')?.value||'').trim().toLocaleLowerCase();
    const found=catalog().filter(p=>(p.title+' '+p.kind+' '+p.description).toLocaleLowerCase().includes(query));
    results.replaceChildren();
    found.forEach(p=>{
      const button=text('button','');button.type='button';button.dataset.openProduct=p.dialog;
      button.append(text('span',p.title),text('small',p.kind));results.append(button);
    });
    $('[data-search-empty]').hidden=found.length>0;
  }
  function renderList() {
    const items=$('[data-shortlist-items]');if(!items)return;
    const entries=catalog();list=list.filter(x=>entries.some(p=>p.title===x.title));
    items.replaceChildren();
    list.forEach((item,index)=>{
      const p=entries.find(x=>x.title===item.title);
      const row=text('article','', 'shortlist-row');
      const img=document.createElement('img');img.src=p.image;img.alt=p.title;
      const copy=text('div','');copy.append(text('h3',p.title));
      const id='ShortlistQuantity'+index;const label=text('label','Approximate quantity');label.htmlFor=id;
      const input=document.createElement('input');input.id=id;input.type='number';input.min='1';input.max='1000000';input.step='1';input.inputMode='numeric';input.value=item.quantity;input.dataset.shortlistQuantity=item.title;
      copy.append(label,input);
      const remove=text('button','×');remove.type='button';remove.dataset.removeQuote=item.title;remove.setAttribute('aria-label','Remove '+item.title);
      row.append(img,copy,remove);items.append(row);
    });
    $$('[data-quote-count]').forEach(e=>e.textContent=String(list.length));
    $('[data-shortlist-empty]').hidden=list.length>0;
    $('[data-shortlist-enquire]').disabled=list.length===0;
    $$('[data-add-quote]').forEach(button=>{const added=list.some(p=>p.title===button.dataset.addQuote);button.classList.toggle('is-added',added);button.setAttribute('aria-pressed',String(added));});
  }
  function saveList(){try{localStorage.setItem(storeKey,JSON.stringify(list));}catch{}
  // Mobile touch pagination dots for product catalog rail
  function updateProductDots() {
    const container = $('[data-product-dots]');
    const grid = $('.product-grid');
    if (!container || !grid) return;
    const visibleCards = cards().filter(c => !c.hidden);
    if (visibleCards.length <= 1) { container.innerHTML = ''; return; }
    
    // Ensure correct number of dots
    if (container.children.length !== visibleCards.length) {
      container.replaceChildren();
      visibleCards.forEach((c, idx) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'home-carousel-dot' + (idx === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to ' + (c.dataset.title || ('item ' + (idx + 1))));
        dot.setAttribute('aria-current', String(idx === 0));
        dot.addEventListener('click', () => {
          c.scrollIntoView({ behavior: reduce.matches ? 'instant' : 'smooth', block: 'nearest', inline: 'start' });
        });
        container.append(dot);
      });
    }

    // Determine currently active card based on scrollLeft
    const gridRect = grid.getBoundingClientRect();
    let minDiff = Infinity, activeIdx = 0;
    visibleCards.forEach((c, idx) => {
      const cRect = c.getBoundingClientRect();
      const diff = Math.abs(cRect.left - gridRect.left);
      if (diff < minDiff) { minDiff = diff; activeIdx = idx; }
    });
    [...container.children].forEach((dot, idx) => {
      const isCur = idx === activeIdx;
      dot.classList.toggle('active', isCur);
      dot.setAttribute('aria-current', String(isCur));
    });
  }

  const gridEl = $('.product-grid');
  if (gridEl) {
    gridEl.addEventListener('scroll', () => {
      requestAnimationFrame(updateProductDots);
    }, { passive: true });
  }

  updateProductDots();
  renderList();}
  function openList(){closePanel(false);renderList();const d=$('#PageOneShortlist');if(d&&!d.open)d.showModal();}
  function chooseProduct(title, variant) {
    ['#QuoteProduct', '#ModalQuoteProduct'].forEach(selId => {
      const select = $(selId);
      if (!select) return;
      let option = [...select.options].find(x => x.value === title);
      if (!option) { option = new Option(title, title); select.add(option); }
      select.value = title;
    });
    if (variant) {
      if ($('#QuoteBranding')) $('#QuoteBranding').value = variant;
      if ($('#ModalQuoteBranding')) $('#ModalQuoteBranding').value = variant;
    }
  }
  function openQuoteModal(title, variant) {
    closePanel(false);
    if (title) chooseProduct(title, variant);
    const d = $('#PageOneQuoteModal');
    if (d && !d.open) {
      d.showModal();
      requestAnimationFrame(() => $('#ModalQuoteName')?.focus({preventScroll:true}));
    }
  }
  function applyFilter(category) {
    let count=0;
    cards().forEach(card=>{card.hidden=category==='gifts'?!['Combos','Hampers'].includes(card.dataset.kind):category!=='all'&&card.dataset.kind!==category;if(!card.hidden)count++;});
    $$('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===category)));
    $$('[data-result-count]').forEach(e=>e.textContent=String(count));
    const empty=$('.filter-empty');if(empty)empty.hidden=count>0;
    $('.product-grid')?.scrollTo({left:0,behavior:'instant'}); updateProductDots();
  }
  document.addEventListener('click', event=>{
    const target=event.target.closest('button,a,[data-panel-backdrop]');if(!target)return;
    if(target.matches('[data-menu-toggle]'))openPanel('menu',target);
    else if(target.matches('[data-search-toggle]'))openPanel('search',target);
    else if(target.matches('[data-panel-backdrop]'))closePanel();
    else if(target.matches('[data-clear-search]')){$('#PageOneSearchInput').value='';renderSearch();$('#PageOneSearchInput').focus();}
    else if(target.matches('[data-open-product]')){event.preventDefault();openProduct(target.dataset.openProduct);}
    else if(target.matches('[data-close-dialog]'))target.closest('dialog')?.close();
    else if(target.matches('[data-open-shortlist]'))openList();
    else if(target.matches('[data-add-quote]')){
      const title=target.dataset.addQuote;if(!list.some(p=>p.title===title))list.push({title,quantity:1});
      saveList();announce(title+' added to your quote shortlist.');openList();
    }
    else if(target.matches('[data-remove-quote]')){list=list.filter(p=>p.title!==target.dataset.removeQuote);saveList();announce('Piece removed from your shortlist.');}
    else if(target.matches('[data-shortlist-enquire]')){
      const lines=list.map(p=>p.title+': approximately '+p.quantity+' units');
      chooseProduct(list.length===1?list[0].title:'Multiple pieces / quote shortlist');
      ['#PageOneQuote', '#PageOneQuoteModalForm'].forEach(fId => {
        const form = $(fId);
        if (!form) return;
        let hidden = $('[name="contact[shortlist]"]', form);
        if (!hidden) { hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = 'contact[shortlist]'; form.append(hidden); }
        hidden.value = lines.join('\n');
      });
      const marker='My Page One quote shortlist:\n';
      const shortlistText = marker + lines.join('\n');
      ['#QuoteMessage', '#ModalQuoteMessage'].forEach(mId => {
        const message = $(mId);
        if (message) {
          const original = message.value.split(marker)[0].trim();
          message.value = (original ? original + '\n\n' : '') + shortlistText;
        }
      });
      const totalQty = String(list.reduce((sum,p)=>sum+p.quantity,0));
      if($('#QuoteQuantity')) $('#QuoteQuantity').value = totalQty;
      if($('#ModalQuoteQuantity')) $('#ModalQuoteQuantity').value = totalQty;
      $('#PageOneShortlist').close();
      openQuoteModal();
    }
    else if(target.matches('[data-filter]'))applyFilter(target.dataset.filter);
    else if(target.matches('[data-show-gifts]')){applyFilter('gifts');$('#collection')?.scrollIntoView({behavior:reduce.matches?'instant':'smooth'});}
    else if(target.matches('[data-quote-product]')){
      event.preventDefault();
      const dialog=target.closest('dialog');const variant=$('[data-product-variant]',dialog||document)?.value;
      const title=target.dataset.quoteProduct;
      dialog?.close();
      closePanel(false);
      openQuoteModal(title, variant);
    }
    else if(target.closest('#PageOneMenu'))closePanel(false);
    else if(target.matches('[data-quote-occasion]')){const e=$('#QuoteOccasion');if(e)e.value=target.dataset.quoteOccasion;}
  });
  document.addEventListener('input',event=>{
    if(event.target.matches('[data-catalog-search]'))renderSearch();
    if(event.target.matches('[data-shortlist-quantity]')){
      const item=list.find(x=>x.title===event.target.dataset.shortlistQuantity);
      if(item){item.quantity=Math.max(1,Math.min(1000000,parseInt(event.target.value,10)||1));try{localStorage.setItem(storeKey,JSON.stringify(list));}catch{}}
    }
  });
  document.addEventListener('keydown',event=>{
    if(!panel)return;
    if(event.key==='Escape'){event.preventDefault();closePanel();}
    if(event.key==='Tab'){
      const visible=$$('a,button,input', $('[data-pageone-header]')).filter(e=>!e.closest('[hidden]')&&e.getClientRects().length&&!e.disabled);
      const first=visible[0],last=visible.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
    }
  });
  $$('dialog').forEach(dialog=>dialog.addEventListener('click',e=>{
    if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}
  }));
  renderList();
  // Matched reveal profiles: masked headline, body, card, media and button.
  // Default DOM is visible. WAAPI only supplies a temporary entrance when observed.
  const revealed=new WeakSet();const animations=new Set();
  const ease='cubic-bezier(.25,1,.35,1)';
  function run(el,frames,options){if(!el.animate||reduce.matches)return;const a=el.animate(frames,{easing:ease,fill:'backwards',...options});animations.add(a);a.finished.then(()=>animations.delete(a)).catch(()=>animations.delete(a));}
  function reveal(el) {
    if(revealed.has(el))return;revealed.add(el);
    if(reduce.matches)return;
    const type=el.dataset.reveal;
    const index=el.matches('.product-card')?cards().filter(x=>!x.hidden).indexOf(el)%3:0;
    if(type==='heading'||type==='hero-heading'){
      const visibleLabel=el.innerText.replace(/\s+/g,' ').trim();el.setAttribute('aria-label',visibleLabel);
      const walker=document.createTreeWalker(el,NodeFilter.SHOW_TEXT);const nodes=[];while(walker.nextNode())if(walker.currentNode.textContent.trim())nodes.push(walker.currentNode);
      let i=0;
      nodes.forEach(node=>{const fragment=document.createDocumentFragment();node.textContent.split(/(\s+)/).forEach(word=>{
        if(!word.trim()){fragment.append(document.createTextNode(word));return;}
        const mask=text('span','', 'word-mask');mask.setAttribute('aria-hidden','true');
        const span=text('span',word,'reveal-word');mask.append(span);fragment.append(mask);
        run(span,[{opacity:0,transform:type==='hero-heading'?'translateY(110%) rotateX(65deg) rotateZ(-3deg)':'translateY(105%)',filter:type==='hero-heading'?'blur(6px)':'blur(2px)'},{opacity:1,transform:'translateY(0) rotateX(0) rotateZ(0)',filter:'blur(0)'}],{duration:type==='hero-heading'?950:760,delay:Math.min(i++*65,420)+(type==='hero-heading'?100:0)});
      });node.replaceWith(fragment);});
    } else if(type==='hero-image'){
      run(el,[{opacity:0,transform:'translateY(24px) scale(.98)'},{opacity:1,transform:'translateY(0) scale(1)'}],{duration:850,delay:120});
    } else {
      const profiles={body:[18,620],pill:[5,480],card:[18,620],image:[12,660],button:[14,520]};
      const [y,duration]=profiles[type]||[12,620];
      run(el,[{opacity:0,transform:'translateY('+y+'px)'},{opacity:1,transform:'translateY(0)'}],{duration,delay:Math.max(0,index)*75});
    }
  }
  const revealObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){reveal(entry.target);revealObserver.unobserve(entry.target);}}),{threshold:.08,rootMargin:'0px 0px -24px 0px'}):null;
  function setupReveals(root=document){$$('[data-reveal]',root).forEach(el=>{if(!revealed.has(el)){if(revealObserver)revealObserver.observe(el);else reveal(el);}});}
  setupReveals();
  // Carousel pauses offscreen, in a hidden tab, during hover/focus and for reduced motion.
  const slides=$$('[data-hero-slide]');const dots=$$('[data-hero-dot]');const stage=$('.hero-stage');let active=0,timer=null;const pauseReasons=new Set();
  function updateSlide(index){
    if(!slides.length)return;active=(index+slides.length)%slides.length;
    slides.forEach((e,i)=>{e.classList.toggle('is-active',i===active);e.setAttribute('aria-hidden',String(i!==active));});
    dots.forEach((e,i)=>e.setAttribute('aria-pressed',String(i===active)));
    const count=$('[data-hero-count]');
    if(count){count.textContent=String(active+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');count.setAttribute('aria-label','Image '+(active+1)+' of '+slides.length);}
    const progress=$('[data-hero-progress]');if(progress)progress.style.transform='translateX('+(active*100)+'%)';
    slides.forEach((slide,i)=>slide.setAttribute('aria-label',(i+1)+' of '+slides.length+': '+slide.dataset.title));
    const slide=slides[active],tag=$('[data-hero-tag]');
    if(tag){tag.dataset.openProduct=slide.dataset.product;$('[data-hero-title]').textContent=slide.dataset.title;$('[data-hero-note]').textContent=slide.dataset.note;}
  }
  function schedule(){clearInterval(timer);timer=null;if(slides.length>1&&!reduce.matches&&pauseReasons.size===0)timer=setInterval(()=>updateSlide(active+1),3600);}
  function pause(reason,value){value?pauseReasons.add(reason):pauseReasons.delete(reason);schedule();}
  dots.forEach(dot=>dot.addEventListener('click',()=>{updateSlide(Number(dot.dataset.heroDot));schedule();}));
  $('[data-hero-prev]')?.addEventListener('click',()=>{updateSlide(active-1);schedule();});
  $('[data-hero-next]')?.addEventListener('click',()=>{updateSlide(active+1);schedule();});
  $('[data-hero-pause]')?.addEventListener('click',e=>{const manual=!pauseReasons.has('manual');pause('manual',manual);e.currentTarget.setAttribute('aria-label',manual?'Play slideshow':'Pause slideshow');$('.pause-symbol',e.currentTarget).textContent=manual?'▷':'Ⅱ';});
  if(stage){
    stage.addEventListener('pointerenter',()=>{if(finePointer.matches)pause('hover',true);});
    stage.addEventListener('pointerleave',()=>{pause('hover',false);stage.style.transform='';});
    stage.addEventListener('focusin',()=>pause('focus',true));
    stage.addEventListener('focusout',e=>{if(!stage.contains(e.relatedTarget))pause('focus',false);});
    let frame=0;
    stage.addEventListener('pointermove',e=>{if(!finePointer.matches||reduce.matches||e.pointerType==='touch')return;const r=stage.getBoundingClientRect(),x=e.clientX,y=e.clientY;cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{stage.style.transform='perspective(900px) rotateX('+((y-r.top)/r.height-.5)*-6+'deg) rotateY('+((x-r.left)/r.width-.5)*6+'deg)';});});
    let start=null;
    stage.addEventListener('pointerdown',e=>{
      if(!e.isPrimary||e.button!==0||e.target.closest('button,a'))return;
      start={x:e.clientX,y:e.clientY,id:e.pointerId};
      stage.setPointerCapture(e.pointerId);pause('gesture',true);stage.classList.add('is-dragging');
    });
    const endGesture=e=>{
      if(!start||e.pointerId!==start.id)return;
      const dx=e.clientX-start.x,dy=e.clientY-start.y;
      if(e.type==='pointerup'&&Math.abs(dx)>Math.max(30,stage.clientWidth*.08)&&Math.abs(dx)>Math.abs(dy)*1.25)updateSlide(active+(dx<0?1:-1));
      if(stage.hasPointerCapture(start.id))stage.releasePointerCapture(start.id);
      start=null;stage.classList.remove('is-dragging');pause('gesture',false);
    };
    stage.addEventListener('pointerup',endGesture);
    stage.addEventListener('pointercancel',endGesture);
    stage.addEventListener('lostpointercapture',()=>{start=null;stage.classList.remove('is-dragging');pause('gesture',false);});
    stage.addEventListener('keydown',e=>{if(e.target!==stage||!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();updateSlide(e.key==='Home'?0:e.key==='End'?slides.length-1:active+(e.key==='ArrowRight'?1:-1));schedule();});
    if('IntersectionObserver'in window)new IntersectionObserver(entries=>pause('offscreen',!entries[0].isIntersecting),{threshold:.1}).observe(stage);
  }
  updateSlide(0);
  document.addEventListener('visibilitychange',()=>pause('hidden',document.hidden));pause('hidden',document.hidden);schedule();
  reduce.addEventListener('change',()=>{if(reduce.matches){animations.forEach(a=>a.cancel());if(stage)stage.style.transform='';}schedule();});
  // The header changes contrast as it crosses the red story chapter.
  let contrastObserver;
  function observeContrast(){
    contrastObserver?.disconnect();if(!('IntersectionObserver'in window))return;
    const h=$('[data-pageone-header]')?.getBoundingClientRect().height||76;
    contrastObserver=new IntersectionObserver(entries=>{entries.forEach(e=>$('[data-pageone-header]')?.classList.toggle('source-contrast',e.isIntersecting));},{rootMargin:'-'+h+'px 0px -'+Math.max(0,innerHeight-h-2)+'px 0px',threshold:0});
    $$('[data-contrast-section]').forEach(e=>contrastObserver.observe(e));
  }
  observeContrast();let resizeFrame=0;window.addEventListener('resize',()=>{cancelAnimationFrame(resizeFrame);resizeFrame=requestAnimationFrame(()=>{closePanel(false);observeContrast();});},{passive:true});
  const date=$('#QuoteDate');if(date){const d=new Date(),pad=n=>String(n).padStart(2,'0');date.min=d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate());}
  const params=new URLSearchParams(location.search);if(params.get('product'))chooseProduct(params.get('product'));
  if(document.body.dataset.localPreview==='true')$('#PageOneQuote, #PageOneQuoteModalForm')?.addEventListener('submit',event=>{event.preventDefault();const f=$('[data-preview-feedback]');if(f)f.textContent='Preview only: no enquiry has been sent. Call +91 77188 67847 to discuss your requirements.';});
  document.addEventListener('shopify:section:load',event=>{setupReveals(event.target);renderList();});
})();
